"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSocketConnected = exports.getSocketId = exports.getConnectId = void 0;

var _errors = require("./errors");

var _providers = require("./providers");

var _state = require("./state");

/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */

/**
 * @param {string} provider WebSocket provider.
 */
var getConnectId = function getConnectId(provider) {
  var _getState = (0, _state.getState)(),
      environment = _getState.environment;

  switch (provider) {
    case _providers.WS_PUSHER:
      return environment.pusherAppKey;

    case _providers.WS_SOCKET_IO:
      return environment.socketIoUrl;

    default:
      throw new Error(_errors.ERR_INVALID_PROVIDER);
  }
};
/**
 * Wrapper for reading socket id. Handles both Socket.io and Pusher instances.
 *
 * @param {object} socket Socket instance.
 *
 * @returns {string} Socket id.
 */


exports.getConnectId = getConnectId;

var getSocketId = function getSocketId(socket) {
  var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _providers.WS_PROVIDER;

  if (provider === _providers.WS_PUSHER) {
    return socket.connection.socket_id;
  }

  if (provider === _providers.WS_SOCKET_IO) {
    var id = socket.id;
    var socketId = id.substr(id.indexOf('#') + 1);
    return socketId;
  }

  throw new Error(_errors.ERR_INVALID_PROVIDER);
};
/**
 * Wrapper for reading socket connection status. Handles both Socket.io and
 * Pusher instances.
 *
 * @param {object} socket Socket instance.
 *
 * @returns {boolean} Is the socket status connected?
 */


exports.getSocketId = getSocketId;

var isSocketConnected = function isSocketConnected(socket) {
  var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _providers.WS_PROVIDER;

  if (!socket) {
    throw new Error(_errors.ERR_INVALID_SOCKET);
  }

  if (provider === _providers.WS_SOCKET_IO) {
    return socket.connected;
  }

  if (provider === _providers.WS_PUSHER) {
    return socket.connection.state === 'connected';
  }

  throw new Error(_errors.ERR_INVALID_PROVIDER);
};

exports.isSocketConnected = isSocketConnected;